import { Fragment } from 'react';
import { asText, Content } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';

import { RichText } from '@preventx/prismic-services';
import { Box, Grid, Heading, GridItem, GradientBorder } from '@preventx/oxygen';

// Services
import { applicationEnv } from '@/services/env/shared';

// Components
import { Link } from '@/components/Actions/Link';

export type DefaultStructureProps = {
  id: string;
  slice: Content.RegionComplexSliceDefault;
};

export const DefaultStructure = ({ id, slice }: DefaultStructureProps) => {
  const { primary } = slice;

  const { title, content, actions, image_1, image_2, image_3, image_4 } =
    primary;

  const { WebsiteUrl } = applicationEnv();

  return (
    <Box addSwitcher component="div" addRegion className="region--partner">
      <Box component="div" addFlow>
        <Heading component="h3" addHeadlineTitle>
          {asText(title)}
        </Heading>

        {content && (
          <RichText
            content={content}
            variant="default"
            websiteUrl={WebsiteUrl}
          />
        )}

        {actions.length > 0 && (
          <Box component="div" addCluster>
            {actions.map((action, index) => (
              <Fragment key={`parter-action-${id}-${index + 1}`}>
                {index === 0 && (
                  <GradientBorder component="div">
                    <Link
                      size="lg"
                      as="default"
                      href={action}
                      type="button"
                      rel="nofollow"
                      retainSearchParams
                    >
                      {action.text}
                    </Link>
                  </GradientBorder>
                )}

                {index > 0 && (
                  <Link
                    size="lg"
                    as="default"
                    href={action}
                    type="button"
                    rel="nofollow"
                    retainSearchParams
                  >
                    {action.text}
                  </Link>
                )}
              </Fragment>
            ))}
          </Box>
        )}
      </Box>

      <Grid
        gap="gap-sm"
        gridType="cols"
        columns={{ all: 3 }}
        className="grid-rows-2"
      >
        <GridItem rows={{ span: 2 }} columns={{ col: 1 }} className="grid-img">
          <PrismicNextImage field={image_1} />
        </GridItem>
        <GridItem columns={{ col: 2 }} className="grid-img">
          <PrismicNextImage field={image_2} />
        </GridItem>
        <GridItem columns={{ col: 3 }} className="grid-img">
          <PrismicNextImage field={image_3} />
        </GridItem>
        <GridItem className="grid-img" columns={{ span: 2 }}>
          <PrismicNextImage field={image_4} />
        </GridItem>
      </Grid>
    </Box>
  );
};
